"use client";
import { useEffect } from "react";

/**
 * HomePage专用的样式重置 hook
 * 确保首页使用标准的 font-size，并清除影响 sticky 定位的样式
 */
export function useHomePageFontSize() {
  useEffect(() => {
    // 重置所有可能影响首页的样式
    const resetStyles = () => {
      // 1. 重置 html font-size 为浏览器默认值 16px
      document.documentElement.style.fontSize = "16px";

      // 2. 重置 html 和 body 的 overflow 设置，确保 sticky 正常工作
      document.documentElement.style.overflow = "";
      document.documentElement.style.overflowX = "";
      document.documentElement.style.overflowY = "";
      
      document.body.style.overflow = "";
      document.body.style.overflowX = "";
      document.body.style.overflowY = "";

      // 3. 移除可能影响滚动的类名
      document.body.classList.remove("fellou-layout-content");
      document.body.classList.remove("fellou-layout-layout-light");
      document.body.classList.remove("fellou-layout-layout-dark");
    };

    // 立即重置
    resetStyles();

    // 防止其他脚本修改，在短时间内再次确保重置
    const timeoutId = setTimeout(resetStyles, 10);

    return () => {
      clearTimeout(timeoutId);
      // 注意：不在这里重置样式，让其他页面自己管理
    };
  }, []);
}